import { useContext } from 'react'

import {
  SessionsProps,
  SessionsContext
} from '@provider/Shared/SessionsProvider'

export default function useSessions(): SessionsProps {
  const context = useContext(SessionsContext)

  return context
}
